import Vue from  'vue'
import Vuex from 'vuex'

import authentication from './modules/authentication'
import journal        from './modules/journal'
import users          from './modules/users'
import blog           from './modules/blog'
import notifications  from './modules/notifications'

import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        authentication,
        journal,
        users,
        blog,
        notifications
    },
    
    plugins: [
        createPersistedState({
            paths: [
                'authentication.auth',
                'users.preferences',
            ],
            storage: {
                getItem: key => Cookies.get(key),
                setItem: (key, value) => Cookies.set(key, value, { expires: 365/*, secure: true*/ }),
                removeItem: key => Cookies.remove(key)
            }
        })
    ] 
})